import { useEffect, useState } from "react";
import { useAuth } from "../Auth/useAuth";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import Base from "../admin_components/Admin_Base";
import "../EmployeeSection/Employeetree.css";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Breadcrumbs } from "@mui/material";
import { ADMIN_API_BASE_URL } from "../Auth/Api"; 
import authAxios from "../Auth/useAxios";
import Link from "@mui/material/Link";

const EmployeeTree = () => {
  const [employeeHierarchy, setEmployeeHierarchy] = useState({});
  const [expanded, setExpanded] = useState({});
  const { token } = useAuth();

  const designationColors = {
    GM: "#3357FF", 
    AGM: "#FF8C00", 
    DO: "#FF5733", 
    DM: "#008080", 
    MO: "#A833FF", 
    Intern: "#FF33A8", 
  };

  const fetchEmployeeHierarchy = async () => {
    try {
      const response = await authAxios.get(`${ADMIN_API_BASE_URL}/main/admin/employees/hierarchy`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Convert the array response to the same format as before
      const hierarchyObject = {};
      response.data.forEach(root => {
        hierarchyObject[root.employeeReferenceId] = root;
      });
      
      setEmployeeHierarchy(hierarchyObject); 
      console.log(response.data, "hierarchy data");
    } catch (error) {
      console.error("❌ Error fetching employee hierarchy:", error);
    }
  };

  // Convert nested structure to flat structure for rendering
  const convertToRenderFormat = (node) => {
    if (!node) return {};
    
    return {
      ...node,
      managerReferenceId: node.manager ? node.manager.employeeReferenceId : null,
      subordinates: node.subordinates ? node.subordinates.map(sub => convertToRenderFormat(sub)) : []
    };
  };

  useEffect(() => {
    if (!token) return;
    fetchEmployeeHierarchy(); 
  }, [token]);

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const renderHierarchy = (nodes) => {
    return Object.values(nodes).map((employee) => {
      const hasChildren = employee.subordinates && employee.subordinates.length > 0;
      const color = designationColors[employee.designation] || "#000"; 

      return (
        <li key={employee.employeeReferenceId} className="hierarchy-item">
          <div
            className="hierarchy-header"
            onClick={() =>
              hasChildren && toggleExpand(employee.employeeReferenceId)
            }
            style={{
              borderLeft: `5px solid ${color}`,
              paddingLeft: "10px",
              backgroundColor: "#f9f9f9", 
              borderRadius: "5px",
              margin: "8px 0",
              width: "60%",
            }}
          >
            {hasChildren &&
              (expanded[employee.employeeReferenceId] ? (
                <FaChevronDown />
              ) : (
                <FaChevronRight />
              ))}
            <span
              className="hierarchy-name"
              style={{ color: color, fontWeight: "bold" }}
            >
              {employee.fullName} ({employee.designation})
            </span>
          </div>

          {expanded[employee.employeeReferenceId] && hasChildren && (
            <ul className="hierarchy-children">
              {renderHierarchy(employee.subordinates)}
            </ul>
          )}
        </li>
      );
    });
  };

  return (
    <Base>
      <div
        className="pt-3 mt-5 res_container"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingRight: "20px",
        }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          className="admin_navigation"
        >
          <Link
            underline="hover"
            key="1"
            color="inherit"
            href="/admin/dashboard"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Dashboard
          </Link>
          <Link
            underline="none"
            key="2"
            color="inherit"
            href="/admin/admin_add_employee"
            sx={{ color: "darkslategrey", fontWeight: "bold" }}
          >
            Employee Tree
          </Link>
        </Breadcrumbs>
      </div>
      
      <h2 className="text-center fw-bold main_heading">Employee Hierarchy</h2>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <hr style={{ width: "94%" }} />
      </div>

      <div className="hierarchy-container">
        <ul className="hierarchy-list">
          {Object.keys(employeeHierarchy).length > 0 ? (
            renderHierarchy(employeeHierarchy)
          ) : (
            <li className="hierarchy-item">
              <div className="text-center text-muted">Loading employee hierarchy...</div>
            </li>
          )}
        </ul>
      </div>
    </Base>
  );
};

export default EmployeeTree;